import { VisionKeyVO as BaseVisisonKeyVO } from '@wizeoo/akm-compute-lib';
import { ChronocodeVO } from './../core/chronocode.vo';
import { VisionKey } from '@wizeoo/akm-message-lib';
import { FreeDataVO } from '../core/freedata.vo';
import { Model } from '../../model/model';
import { ViewData } from '../../model/view.data';

/** encapsulation d'une clé de vision (Freedata ou Chronocode). Permet la restitution du label explicite (le level dans le cas des éléments gigognes) */
export class VisionKeyVO extends BaseVisisonKeyVO {

  constructor(model: Model, pSource: VisionKey) {
    super(model, pSource);
  }

  protected get model(): Model {
    return this._model as Model;
  }
  protected set model(value: Model) {
      this._model = value;
  }

  private _splittedCode: string[];

  public get splittedCode(): string[] {
    if (!this._splittedCode) {
      this._splittedCode = this.code.split(ViewData.CONTEXT_SEPARATOR);
    }

    return this._splittedCode;
  }

  public get level(): number {
    return this.source.level;
  }
  public set level(value: number) {
    this.source.level = value;
  }

  /** retourne le code pour les chronos ou les FDs */
  public get dataKeyAllTheWays(): string {
    if (this.isFD) {
      if(!!this.getRelatedFd()) {
        return this.getRelatedFd().code;
      } else {
        return 'Scen@r'; // TODO, utilisé pour l'export Excel
      }
      
    } else if (this.isChrono) {
      return this.getRelatedChrono()?.code;
    } else {
      return null;
    }
  }

  /* ############################################
   *       Collecte des VOs
   * ############################################ */

  // [MOTEUR BACK] On récupére ici des instances "ihm"
  public override getRelatedFd(): FreeDataVO {
    return super.getRelatedFd() as FreeDataVO;
  }

  public override getRelatedChrono(): ChronocodeVO {
    return super.getRelatedChrono() as ChronocodeVO;
  }

  /* ################################################
   *                  Accesseurs composites
   * ################################################ */
  /**
   * Accés simplifié au label traduit à partir de la locale en cours d'utilisation dans l'appli
   */
  public get trsLabel(): string {
    return this.model.visionEngine.getKeyLabel(this);
  }

  /** libellé ordre + label */
  public get orderAndlabel(): string {
    return this.order + ' - ' + this.model.visionEngine.getKeyLabel(this);
  }
}
